export const globalPagerOptions = {
    MAX_PER_PAGE: 100,
};

export interface IPaginationData<T> {
    data: T[];
    pages: number;
}
